export default "__VITE_ASSET__9189aeef__"